module.exports = __webpack_public_path__ + "images/a4-portrait-cbd4ad0ac46389f9cf0333647e56a6de.jpg";